export default __webpack_public_path__ + "img/b2e6444be7d090779f99a611fbe8c9b2.png";